import FadeInWhenInView from "../../../animations/FadeInWhenInView"
import { InfoType } from "./Infos"

const SingleInfo = ({info}: {info: InfoType}) => {
    return(
        <div className={`flex flex-col gap-8 w-full md:w-1/2 ${info.id%2 === 0 ? 'md:self-end' : ''}`}>
            <FadeInWhenInView delay={0} margin={0.2}>
                {
                    info.isVideo?
                        <div className={`w-80 mb-24 lg:mb-60 flex flex-col ${info.id%2 === 0 ? 'md:self-end' : ''}`}>
                        </div>
                        :
                        <div className={`mx-8 w-1/3 md:w-40 aspect-square xl:w-64 flex ${info.id%2 === 0 ? 'md:self-end' : ''}`}>
                            <img src={info.img_url} alt="not found" className={`object-cover self-center ${info.id%2 === 0 ? 'md:self-end' : ''}`}/>
                        </div>


                }
                </FadeInWhenInView>
                    <FadeInWhenInView delay={0} margin={0.2}><div className={`text-xl md:text-2xl xl:text-3xl uppercase font-semibold ${info.id%2 === 0 ? 'md:self-end' : ''}`}>{info.title}</div></FadeInWhenInView>
                    <FadeInWhenInView delay={0} margin={0.2}><div className={`text-sm lg:text-lg dark:text-gray text-darkgray uppercase ${info.id%2 === 0 ? 'md:text-right' : ''}`}>{info.subtitle}</div>
                </FadeInWhenInView>
            </div>
    )
}

export default SingleInfo